<script>
import { VSwitch } from 'vuetify/lib'
import { VFabTransition, VProgressCircular } from 'vuetify/lib/components'
import { prevent } from 'vuetify/lib/mixins/selectable/index'
import { getSlot } from 'vuetify/lib/util/helpers'

export default {
  name: 'ESwitch',
  extends: VSwitch,
  props: {
    detail: { type: String, default: '' },
    hideDetails: {
      type: [Boolean, String],
      default: 'auto',
    },
  },
  computed: {
    classes() {
      return {
        'e-switch': true,
        ...VSwitch.options.computed.classes.call(this),
        'v-input--switch--flat': true,
        'v-input--switch--inset': true,
        'e-switch--is-focused': this.isFocused,
        'e-switch--is-disabled': this.isDisabled,
      }
    },
  },
  methods: {
    genSwitchContent() {
      return this.$createElement(
        'div',
        {
          staticClass: 'e-switch__content',
        },
        [this.genLabel(), this.genDetail()]
      )
    },
    genLabel() {
      if (!this.label) return null
      return this.$createElement(
        'label',
        {
          on: {
            // Label shouldn't cause the input to focus
            click: prevent,
          },
          attrs: {
            for: this.computedId,
          },
          staticClass: 'e-switch__label',
        },
        this.label
      )
    },
    genDetail() {
      if (!this.detail) return null
      return this.$createElement(
        'span',
        {
          staticClass: 'e-switch__detail',
        },
        getSlot(this, 'detail') || this.detail
      )
    },
    genSwitch() {
      const { title, ...switchAttrs } = this.attrs$
      return this.$createElement(
        'div',
        {
          staticClass: 'v-input--selection-controls__input',
        },
        [
          this.genInput('checkbox', { ...this.attrs, ...switchAttrs }),
          this.$createElement('div', {
            staticClass: 'e-switch__track',
            class: {
              'e-switch__track--active': this.isActive,
            },
          }),
          this.$createElement(
            'div',
            {
              staticClass: 'e-switch__track-dot',
              class: {
                'e-switch__track-dot--active': this.isActive,
              },
            },
            [this.genProgress()]
          ),
        ]
      )
    },
    genProgress() {
      return this.$createElement(VFabTransition, {}, [
        this.loading === false
          ? null
          : this.$slots.progress ||
            this.$createElement(VProgressCircular, {
              props: {
                color: this.loading === true || this.loading === '' ? this.color || 'primary' : this.loading,
                size: 16,
                width: 2,
                indeterminate: true,
              },
            }),
      ])
    },
    genDefaultSlot() {
      return [this.genSwitch(), this.label || this.detail ? this.genSwitchContent() : null]
    },
  },
}
</script>
